import { Icon } from 'View/Common';
import { StyledModal, ModalBody } from './AudioPlayerModal.style';
import { colors } from 'View/Theme';
import { FC } from 'react';

type AudioPlayerModalProps = {
  toggle: () => void;
  isOpen: boolean;
  courseImage: string;
  courseAudio: string;
  onClose: () => void;
  audioId: string;
};

export const AudioPlayerModal: FC<AudioPlayerModalProps> = ({ toggle, isOpen, courseImage, courseAudio, onClose, audioId }) => {
  return (
    <StyledModal className="audio-player-modal" isOpen={isOpen} toggle={toggle} onOpened={onClose}>
      <ModalBody>
        <button className="close-button" onClick={toggle}>
          <Icon name="Close" className="close_icon" color={colors.sleep.beige.c100} />
        </button>
        <img className="modal-image" src={courseImage} />
        <audio src={courseAudio} id={audioId} className="audio-player" controls={true} autoPlay />
      </ModalBody>
    </StyledModal>
  );
};
